/**
 * Hook for fetching base image configuration and runtime status.
 */

import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import type { BaseImageInfo } from '../schemas/admin.schemas';

export const BASE_IMAGE_KEY = ['admin-base-image'];

export function useBaseImageInfo() {
  return useQuery<BaseImageInfo>({
    queryKey: BASE_IMAGE_KEY,
    queryFn: () => adminApi.getBaseImageInfo(),
  });
}
